import { Menu, MenuItem, useTheme } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import WalletIcon from "@mui/icons-material/Wallet";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCredentials } from "../features/counter/Authslice.js";
import { clearSelectedCompany } from "../features/counter/kycSlice.js";
import config from "../config";
import axios from "axios";
import "../styles/navbar.css";
import { Link } from "react-router-dom";

const MenuItemLogout = ({ anchorEl, handleClose }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { API_BASE_URL } = config;

  const handleLogout = async () => {
    try {
      
      await axios.get(`${API_BASE_URL}/api/v1/logout`, {
        withCredentials: true,
      });
    } catch (error) {
      console.error("Logout API error:", error);
      
    } finally {
   
      sessionStorage.removeItem("accessToken"); 
      localStorage.removeItem("refreshToken");
      delete axios.defaults.headers.common["Authorization"];
      
      
      dispatch(clearCredentials());
      dispatch(clearSelectedCompany());
      
      
      navigate("/login", { replace: true });
    }
  };

  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="ms-2 mt-3"
      >
        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <PersonIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/accountprofile"
          >
            My Profile
          </Link>
        </MenuItem>

        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <BookOnlineIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/MyBookings"
          >
            My Bookings
          </Link>
        </MenuItem>

        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <WalletIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/MyWallate"
          >
            My Wallet
          </Link>
        </MenuItem>

        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <SubscriptionsIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/SubscriptionPlan"
          >
            My Subscription
          </Link>
        </MenuItem>

        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <AdUnitsIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/accountprofile?page=Notifications"
          >
            Notifications
          </Link>
        </MenuItem>

        <MenuItem onClick={handleClose} className="menu-font border-bottom">
          <SettingsIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          <Link
            style={{
              color: theme.palette.text.secondary,
              textDecoration: "none",
              fontSize: "16px",
            }}
            to="/accountprofile?page=Security"
          >
            Settings
          </Link>
        </MenuItem>

        <MenuItem onClick={handleLogout} className="menu-font">
          <LogoutIcon className="me-2" style={{ color: theme.palette.primary.main }} />
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuItemLogout;
